@if (showMore) {
  <button mat-icon-button class="close-button" (click)="onClose()">
    <mat-icon class="close-icon" >X</mat-icon>
  </button>
}
<h1
  mat-dialog-title
  style="border-bottom: 1px solid #eeeeee; text-align: center;height: 60px;"
  >
  {{ data.name }} <br />
  (CSLB # {{ data.licenseNo }})
</h1>

<div mat-dialog-content style="overflow:auto;height: 400px;">
  @for (review of data.reviews; track review; let i = $index) {
    <div>
      @if (i < data.previewLimit || showMore) {
        <div>
          <strong>{{ review.createdOn | date: 'shortDate' }} :</strong>
          {{ review.review }} <br />
          @if (canShowResponse(review)) {
            <div>
              <strong>
                <a href="#" (click)="updateToggleCollapse(review.id)"
                  >See Contractor response</a
                  ></strong
                  >
                  @if (toggleCollapse(review.id)) {
                    <div style="padding: 10px;">
                      <strong>{{ review.responseDate | date: 'shortDate' }} :</strong>
                      {{ review.response }}
                    </div>
                  }
                </div>
              }
              <mat-divider></mat-divider>
            </div>
          }
        </div>
      }

    </div>


    <div mat-dialog-actions  style="height: 80px;">

      @if (!showMore && data.reviews.length >= data.previewLimit) {
        <div style="width: 100%; text-align: center;" >
          <button mat-button
            color="primary"
            (click)="onMore()">
            View More
          </button>
        </div>
      }
      <div  style="width: 100%; text-align: center;">

        <button mat-button
          (click)="onClose()">
          Close
        </button>
      </div>
    </div>
